import api from "./api";

const sid = (() => {
  let s = sessionStorage.getItem("uvdj_sid");
  if (!s) {
    s = Math.random().toString(36).slice(2) + Date.now().toString(36);
    sessionStorage.setItem("uvdj_sid", s);
  }
  return s;
})();

export const track = (type, detail = "") => {
  try {
    api.post("/telemetry", {
      session_id: sid,
      events: [{ type, page: window.location.pathname, detail: String(detail).slice(0, 200), ts: Date.now() }],
    }).catch(() => {});
  } catch { /* noop */ }
};
